/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type userTracking_viewer$ref = any;
export type userTracking_viewer = {
    readonly submittedTransactions?: {
        readonly totalResults: number | null;
    } | null;
    readonly confirmedTransactionsMostRecent?: {
        readonly totalResults: number | null;
    } | null;
    readonly " $refType": userTracking_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds"
    } as any), v1 = ({
        "kind": "Literal",
        "name": "first",
        "value": 0
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "userTracking_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "submittedTransactions",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "viewName",
                                "value": "buyerTracking.submitted"
                            }
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "confirmedTransactionsMostRecent",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "viewName",
                                "value": "buyerTracking.confirmed"
                            }
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '66e5cb83825561cf95a1ffbee495f904';
export default node;
